import React, { memo } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';

const selectStyles = {
  placeholder: (base) => ({
    ...base,
    fontWeight: 'normal',
    color: 'var(--text-gray)',
  }),
  control: (base) => ({
    ...base,
    border: 'none',
    boxShadow: 'none',
    flexWrap: 'nowrap',
  }),
  indicatorSeparator: (base) => ({ ...base, visibility: 'hidden' }),
  dropdownIndicator: (base) => ({ ...base, padding: '8px 0px' }),
  clearIndicator: (base) => ({ ...base, padding: '8px 0px' }),
};

function DmAlertsFiltersDropdown(props) {
  const { displayText, filter, options, handleOptionSelect } = props;
  const conditionalStyles =
    filter === 'sa'
      ? {
          menu: (base) => ({
            ...base,
            width: '150%',
          }),
        }
      : {};
  return (
    <Select
      isClearable
      onChange={(value) => handleOptionSelect(value, filter)}
      options={options}
      placeholder={displayText}
      ref={props[`${filter}FilterRef`]}
      styles={{ ...selectStyles, ...conditionalStyles }}
    />
  );
}

DmAlertsFiltersDropdown.propTypes = {
  displayText: PropTypes.oneOf(['SPN', 'FMI', 'Source', 'CAN', 'Occurrences']),
  filter: PropTypes.oneOf(['spn', 'fmi', 'sa', 'canbus', 'oc']),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number,
      label: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    })
  ),
  handleOptionSelect: PropTypes.func,
};

DmAlertsFiltersDropdown.defaultProps = { options: [] };

export default memo(DmAlertsFiltersDropdown);
